import { Component, ViewChild, inject } from "@angular/core";
import { RecaptchaComponent } from "ng-recaptcha";
import { ActivatedRoute, Router } from "@angular/router";
import { CaptchaService } from "src/app/services/captcha.service";
import { environment } from "src/environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { faro } from "@grafana/faro-web-sdk";
import Swal from "sweetalert2";
import { NavigationEnum } from "src/app/dispute-form-module/globalvar";

@Component({
  selector: "app-captcha-component",
  templateUrl: "./captcha.component.html",
  styleUrls: ["./captcha.component.scss"],
})
export class CaptchaComponent {
  @ViewChild("captchaEl", { static: false }) captchaEl!: RecaptchaComponent;

  token: string | undefined;
  siteKey: string = environment.recaptcha.siteKey;
  isProd: boolean = environment.production;

  faroErrorHandler(error: Error | string) {
    const errorObj = typeof error === 'string' ? new Error(error) : error;
    if (typeof window !== 'undefined' && (globalThis as { faroInitialized?: boolean }).faroInitialized) {
      faro.api.pushError(errorObj);
    }
  }

  private captchaService = inject(CaptchaService);
  private router = inject(Router);
  private r = inject(ActivatedRoute);
  private _translate = inject(TranslateService);

  constructor() {
    this.token = undefined;

    if(!this.isProd){
      this.token = "1";
      this.captchaService.setValid(true);
    }

    this.captchaService.isValid$.subscribe({
      next: (val: boolean) => {
        if (!val && this.token) {
          this.expireCaptcha();
        }
      },
    });

    this._translate.onLangChange.subscribe((lang: { lang: string }) => {
      const recaptchaEl = document.getElementById("recaptcha");
      if (recaptchaEl) {
        this.setCaptchaLang(recaptchaEl, lang.lang);
      }
    });
  }

  async captchaResponse(captchaToken: string) {
    if (captchaToken) {
      try {
        this.captchaService.validateCaptcha(captchaToken).subscribe(
          (r: any) => {
            if (r.success) {
              this.token = captchaToken;
            } else {
              this.expireCaptcha();
              const err = new Error("Cannot Compute");
              this.faroErrorHandler(err);
              throw err;
            }
          },
          (resp: any) => {
            this.expireCaptcha();
            Swal.fire(this._translate.instant("Error.Error"), resp.message, "error");
          }
        );
      } catch (err) {
        this.expireCaptcha();
        Swal.fire(this._translate.instant("Error.Error"), (err as Error).message, "error");
      }
    } else {
      Swal.fire(this._translate.instant("Error.Error"), this._translate.instant("Error.InvalidCaptcha"), "error");
    }
  }

  startDispute() {
    this.router.navigate([NavigationEnum.TERM_AGREEMENT]);
  }

  expireCaptcha() {
    this.token = undefined;
    if (this.captchaEl && typeof this.captchaEl.reset === 'function') {
      this.captchaEl.reset();
    }
    this.captchaService.setValid(false);
  }

  setCaptchaLang(recaptchaContainer: HTMLElement, lang: string) {
    lang = lang || "en";

    const iframeGoogleCaptcha = recaptchaContainer.querySelector("iframe");

    if (iframeGoogleCaptcha instanceof HTMLIFrameElement) {
      const src = iframeGoogleCaptcha.getAttribute("src") || "";
      const match = src.match(/hl=(.*?)&/);
      const currentLang = match ? match[1] : "en";
      if (currentLang !== lang) {
        iframeGoogleCaptcha.setAttribute(
          "src",
          src.replace(/hl=(.*?)&/, "hl=" + lang + "&")
        );
      }
    }
  }
}
